export type Environment = "production" | "staging" | "development" | "test";

// NOTE:
// - environment is read from the APP_ENV environment variable
//   - it falls back to 'production' like in the config/env.js file
//   - for tests there isn't a document.body therefore the environment for
//     tests is 'production' by default. Set it accordingly in your tests.
// - the other config attributes are read from the .env files
export interface IConfig {
  environment: Environment;
  saltcomplianceApiRoot: string;
  saltcomplianceUserDashboardUrl: string;
  saltcomplianceUsersExportFilename: string;
  saltcomplianceVersion: string;
}

export const config: IConfig = {
  environment: (document.body.getAttribute("data-environment") as Environment) || "production",
  saltcomplianceApiRoot: document.body.getAttribute("data-saltcompliance-api-root") || "",
  saltcomplianceUserDashboardUrl: document.body.getAttribute("data-saltcompliance-user-dashboard-url") || "",
  saltcomplianceUsersExportFilename: "export.csv",
  saltcomplianceVersion: document.body.getAttribute("data-saltcompliance-version") || "",
};
